const LogoHomePage = () => {
  return (
    <img width="auto" height="250px" alt="spotlight-logo" src="/logo.svg" />
  );
};

export default LogoHomePage;
